import { ErrorBoundary, JSXElement, Match, mergeProps, Switch } from 'solid-js';
import ContactSupport from '~/components/ErrorBoundaries/ContactSupport.tsx';
import { logErrorToSentry } from '~/utils/productLogging/sentry.ts';
import { AppErrors } from '~/components/ErrorBoundaries/utils.ts';
import PortalLinkExpired, {
  ApiRequestFailedContext,
  LinkExpiredContext
} from '~/components/ErrorBoundaries/PortalLinkExpired.tsx';
import { isLoadedInIframe } from '~/utils/commonUtils.ts';
import logger from '~/utils/logger';

type AppErrorBoundaryProps = {
  children: JSXElement;
};

export default function AppErrorBoundary(
  props: AppErrorBoundaryProps
): JSXElement {
  const merged = mergeProps({}, props);
  return (
    <ErrorBoundary
      fallback={(err) => {
        logErrorToSentry(err);
        logger.info(`Rendering from error boundary`, err);
        return (
          <Switch>
            <Match
              when={
                err instanceof Error &&
                err.message === AppErrors.CUSTOMER_PORTAL_SESSION_EXPIRED
              }
            >
              <PortalLinkExpired
                context={
                  isLoadedInIframe()
                    ? LinkExpiredContext.EMBEDDED_ADMIN_PORTAL
                    : LinkExpiredContext.STANDALONE_ADMIN_PORTAL
                }
              />
            </Match>
            <Match
              when={
                err instanceof Error &&
                err.message === AppErrors.CUSTOMER_PORTAL_REQUEST_FAILED
              }
            >
              <PortalLinkExpired
                context={
                  isLoadedInIframe()
                    ? ApiRequestFailedContext.EMBEDDED_PORTAL
                    : ApiRequestFailedContext.STANDALONE_PORTAL
                }
              />
            </Match>
            <Match when={true}>
              <ContactSupport showLogo={true} />;
            </Match>
          </Switch>
        );
      }}
    >
      {merged.children}
    </ErrorBoundary>
  );
}
